export class HistoryTaskConfig{
  // Configuraciones de la tabla
  settings = {};

  constructor() {
    this.settings = {
      mode: 'external',
      noDataMessage: 'La tarea actual no contiene historial',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        dependencia: {
          editable: false,
          addable: false,
          class: 'prueba',
          title: 'Dependencia remitente',
          filter: {
            inputClass: 'form-control',
          },
        },
        remitente: {
          editable: false,
          addable: false,
          class: 'prueba',
          title: 'Remitente',
          filter: {
            inputClass: 'form-control',
          },
        },
        dependencia_asignado: {
          editable: false,
          addable: false,
          class: 'prueba',
          title: 'Dependencia asignado',
          filter: {
            inputClass: 'form-control',
          },
        },
        asignado: {
          title: 'Asignado a',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          },
        },
        asunto: {
          title: 'Asunto',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          }
        },
        descripcion: {
          title: 'Descripción',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          }
        },
        fecha_correo: {
          title: 'Fecha del correo',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          }
        }
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/history-task/shared/history-task.config.service.ts